<script>
  let { transfer, members, projects, types, onSave, onCancel } = $props();

  let edited = $state({ ...transfer });
  let submitted = $state(false);

  function isValid() {
    return edited.typ !== undefined && edited.typ !== null;
  }

  function ok() {
    submitted = true;
    if (!isValid()) return;
    onSave(edited);
  }
</script>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">Edycja przelewu</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form name="theForm" class="form form-inline" onsubmit={(e) => { e.preventDefault(); ok(); }} role="form">
            <table class="table table-condensed table-hover table-striped">
			<tbody>
              <tr>
  				<td>
  				Data i czas importu:
  				</td>
  				<td>
                  {edited.data_imp}
  				</td>
  			  </tr>
              <tr>
				<td>
				Data transakcji:
				</td>
				<td>
                {edited.data}
				</td>
			  </tr>
              <tr>
				<td>
				Kontrahent (nadawca albo odbiorca):
				</td>
				<td>
                {edited.kontrahent}
				</td>
			  </tr>
              <tr>
				<td>
				Opis (Tytułem):
				</td>
				<td>
                {edited.opis}
				</td>
			  </tr>
              <tr>
				<td>
				Kwota:
				</td>
				<td>
                {edited.kwota}
				</td>
			  </tr>
              <tr>
				<td>
				Typ przelewu:
				</td>
				<td>
				<select class="form-control input-sm" name="typ" bind:value={edited.typ} required>
				  {#each types as option}<option value={option.idx}>{option.name}</option>{/each}
				</select>
				{#if submitted && (edited.typ === undefined || edited.typ === null)}<small style="color:red">Trzeba wybrać typ</small>{/if}
				</td>
			  </tr>
			  <tr>
				<td>
				Dotyczy osoby:
				</td>
				<td>
				<select class="form-control input-sm" name="osoba" bind:value={edited.idcz}>
                  <option value={null}>[nie dotyczy]</option>
				  {#each members as option}<option value={option.idcz}>{option.imie} {option.nazwisko}</option>{/each}
				</select>
				</td>
			  </tr>
              <tr>
                    <td>
                    Dotyczy projektu:
                    </td>
                    <td>
                    <select class="form-control input-sm" name="projekt" bind:value={edited.idpr}>
                      <option value={null}>[nie dotyczy]</option>
                      {#each projects as option}<option value={option.idpr}>{option.nazwa}</option>{/each}
                    </select>
                    </td>
              </tr>
              <tr>
                <td>
                Notka:
                </td>
                <td>
                <input type="text" class="form-control input-sm" placeholder="Notatka" bind:value={edited.info} name="info" size="40">
                </td>
              </tr>
			</tbody>
			</table>
            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success" onclick={ok}>Zapisz</button>
  <button class="btn btn-default" onclick={onCancel}>Anuluj</button>
</div>
